import { IMG } from "../data/site";
import { PageHero, Section, Overline, EnquiryForm } from "../components/site/bits";
import { Reveal, Stagger, StaggerItem } from "../components/site/motion";
import { Building2, Wrench, ClipboardCheck, ShieldCheck, BadgePoundSterling } from "lucide-react";

const BENEFITS = [
  { icon: Building2, t: "Professional property management", d: "Your property managed to a high standard by an experienced, accountable team." },
  { icon: Wrench, t: "Responsive maintenance", d: "Fast, reliable repairs that protect your property and keep residents safe." },
  { icon: ClipboardCheck, t: "Regular inspections", d: "Routine inspections and clear reporting so you always know your property's condition." },
  { icon: ShieldCheck, t: "Compliance support", d: "Gas, electrical and safety compliance managed on your behalf." },
  { icon: BadgePoundSterling, t: "Reliable rental income", d: "Guaranteed, consistent rent with no void periods or chasing payments." },
];

export default function Landlords() {
  return (
    <>
      <PageHero overline="For Landlords" lines={["Partner with", "purpose."]} image={IMG.business}
        intro="Reliable rental income and professional management — while your property helps someone rebuild their life." />

      <Section>
        <Overline>Why partner with us</Overline>
        <Stagger className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {BENEFITS.map((b) => (
            <StaggerItem key={b.t} className="rounded-2xl border border-brand-dark/10 bg-brand-surface p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-brand-green/40">
              <b.icon className="h-8 w-8 text-brand-green" strokeWidth={1.5} />
              <h3 className="mt-5 font-serif text-xl text-brand-dark">{b.t}</h3>
              <p className="mt-3 text-sm text-brand-slate">{b.d}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>

      <Section className="bg-brand-surface/60">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Overline>Get in touch</Overline>
            <Reveal><h2 className="mt-6 font-serif text-4xl tracking-tight text-brand-dark md:text-5xl">Let's talk about your property.</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-brand-slate">Tell us about your property and we'll explain how a partnership with Shelterease works — including guaranteed rent, management and compliance.</p></Reveal>
            <div className="mt-8 overflow-hidden rounded-2xl"><img src={IMG.handshake} alt="Landlord partnership" className="h-64 w-full object-cover" /></div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal><div className="rounded-3xl border border-brand-dark/10 bg-brand-surface p-8 md:p-12">
              <h2 className="font-serif text-3xl text-brand-dark">Landlord enquiry</h2>
              <div className="mt-8">
                <EnquiryForm kind="landlord" testid="landlord-form" submitLabel="Send enquiry" fields={[
                  { name: "name", label: "Your name", required: true, placeholder: "Full name" },
                  { name: "email", label: "Email", type: "email", required: true, placeholder: "you@email.com" },
                  { name: "phone", label: "Phone", type: "tel", placeholder: "07000 000000" },
                  { name: "property_location", label: "Property location", required: true, placeholder: "e.g. Coventry CV1" },
                  { name: "property_type", label: "Property type", type: "select", placeholder: "Select type", options: ["Flat", "Terraced house", "Semi-detached", "HMO", "Other"] },
                  { name: "message", label: "Tell us about your property", type: "textarea", placeholder: "Bedrooms, condition, availability…" },
                ]} />
              </div>
            </div></Reveal>
          </div>
        </div>
      </Section>
    </>
  );
}
